








import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatPageStructureEditableMixin } from "../../mixins";
import { IConfiguration } from "../../../../../domain/configuration";

@Component
export default class FormatObjectSortTool extends Mixins(FormatPageStructureEditableMixin, ModelEditableMixin) {
  $configuration!: IConfiguration;

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  sortObjectsUpperLeftToRightBottom(): void {
    this.writePropertyWhenValid(s => s.sortByLocation());
  }
}


